import { createFileRoute } from '@tanstack/react-router'

import { SocialFeedPage } from '@/features/social'

export const Route = createFileRoute('/_authenticated/_main/novidades/')({
  component: SocialFeedPage
})
